import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { getTransitionWithVariable } from '../../../../../redux_store';

const SubmissionsStatusWidget = ({
  currentSurvey,
  assessmentStatus,
  classes,
}) => {
  const { en: { instantSurvey } } = useSelector((state) => state.i18n);

  if (!currentSurvey || assessmentStatus === 'draft') return null;

  return (
    <div className={`${classes.section} ${assessmentStatus === 'archived' ? classes.sectionArchived : ''}`}>
      <Typography className={classes.sectionTitle}>
        {instantSurvey.submissionsTitle}
      </Typography>
      <div className={classes.sectionContent}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <div style={{
              textAlign: 'center',
              padding: 16,
              backgroundColor: assessmentStatus === 'archived' ? '#eeeeee' : '#f8f9fa',
              borderRadius: 8,
            }}>
              <Typography variant="h4" style={{
                color: assessmentStatus === 'archived' ? '#757575' : '#1976d2',
                fontWeight: 600,
                fontSize: '1.75rem',
              }}>
                {currentSurvey.currentSubmissions || 0}
              </Typography>
              <Typography variant="body2" color="textSecondary"
                          style={{ fontSize: '0.8rem' }}>
                {instantSurvey.submissionsLabel}
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} lg={6}>
            <div style={{
              textAlign: 'center',
              padding: 16,
              backgroundColor: assessmentStatus === 'archived' ? '#eeeeee' : '#f8f9fa',
              borderRadius: 8,
            }}>
              <Typography variant="h4" style={{
                color: assessmentStatus === 'archived' ? '#757575' : '#4caf50',
                fontWeight: 600,
                fontSize: '1.75rem',
              }}>
                {currentSurvey.maxSubmissions || '∞'}
              </Typography>
              <Typography variant="body2" color="textSecondary"
                          style={{ fontSize: '0.8rem' }}>
                {instantSurvey.maxSubmissionsLabel}
              </Typography>
            </div>
          </Grid>
        </Grid>

        <div style={{ marginTop: 24 }}>
          <Typography variant="body2" color="textSecondary"
                      style={{ marginBottom: 16 }}>
            {getTransitionWithVariable(instantSurvey.createdByText, {
              creator: currentSurvey.createdBy,
              date: new Date(currentSurvey.createdTimestamp).toLocaleDateString('en-CA')
            })}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default SubmissionsStatusWidget;